module.exports = __webpack_public_path__ + "img/img_thumb_0201.2ff8b3d1.png";